import useSeo from '@/hooks/useSeo';
import { faqs, site } from '@/mocks/site';
import HomeHero from './components/HomeHero';
import DimensionGrid from './components/DimensionGrid';
import HotBreakdown from './components/HotBreakdown';
import TimelineCorridor from './components/TimelineCorridor';
import FeaturedDossiers from './components/FeaturedDossiers';
import Testimonials from './components/Testimonials';
import HomeFaq from './components/HomeFaq';
import CtaBand from './components/CtaBand';

export default function Home() {
  useSeo({
    title: '爆料看点 - 爆料背后细节｜被忽略的伏笔与时间线关键节点梳理',
    description:
      '爆料看点专注事件拆解：从爆料背后细节、被忽略的伏笔、时间线关键节点到事件隐藏关联，一层层摊开讲，帮你把零散线索拼成完整脉络。',
    keywords: '爆料看点,爆料背后细节,被忽略的伏笔,时间线关键节点,事件隐藏关联',
    path: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: site.name,
        alternateName: site.enName,
        url: 'https://baoliaokandian.site/',
        description: site.description,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: 'https://baoliaokandian.site/dossiers?q={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: site.name,
        url: 'https://baoliaokandian.site/',
        email: site.email,
        description: site.description,
        foundingDate: site.since,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
    ],
  });

  return (
    <>
      <HomeHero />
      <DimensionGrid />
      <HotBreakdown />
      <TimelineCorridor />
      <FeaturedDossiers />
      <Testimonials />
      <HomeFaq />
      <CtaBand />
    </>
  );
}